import { render } from "./SiteAccessStudy.vue?vue&type=template&id=c8d0f208&scoped=true"
import script from "./SiteAccessStudy.vue?vue&type=script&lang=js"
export * from "./SiteAccessStudy.vue?vue&type=script&lang=js"

import "./SiteAccessStudy.vue?vue&type=style&index=0&id=c8d0f208&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8d0f208"]])

export default __exports__